export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./missing-data.vue?vue&type=template&id=3b8b1c5c&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/missing-data.vue?vue&type=template&id=3b8b1c5c&
// module id = 1707
// module chunks = 0